import { next } from '@ember/runloop';
import { modifier } from 'ember-modifier';
const DEFAULT_FOCUS_DELAY = 50;
const isMarketCodeInput = element => {
  return element.tagName === 'MARKET-CODE-INPUT';
};
export default modifier((element, [submitCallback, submitOnPaste = true, submitOnCompletion = true]) => {
  function handlePaste() {
    next(() => {
      submitCallback();
    });
  }
  function codeInputIsCompleteListener(event) {
    const shadowRoot = element.shadowRoot;
    const codeInputLength = shadowRoot.querySelector('span').querySelectorAll('input').length;
    if (event?.target?.value?.length === codeInputLength) {
      submitCallback(event);
    }
  }
  if (!isMarketCodeInput(element)) {
    return;
  }
  if (submitOnPaste) {
    element.addEventListener('paste', handlePaste);
  }
  if (submitOnCompletion) {
    element.addEventListener('input', codeInputIsCompleteListener);
  }
  setTimeout(() => {
    element.setFocus();
  }, DEFAULT_FOCUS_DELAY);
  return () => {
    element.removeEventListener('paste', handlePaste);
    element.removeEventListener('input', codeInputIsCompleteListener);
  };
});